import { axios, axios2 } from '@/lib/axios';

export const deletePropertyItem = (id: string, propertItemType: string) => {
  const payload = {
    id: id,
    type: propertItemType,
  };
  return axios2.post('/customer-api/delete-properties', payload);
};
